import React, { Component } from 'react';
import './style.css';
import { Modal, ModalHeader } from 'reactstrap';


export class QuoteModalForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      file: {
        error: null,
        value: null,
      },
      textarea: '',

    };
    this.onUploadFile = this.onUploadFile.bind(this);
    this.handleTextareaChange = this.handleTextareaChange.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  onSubmitForm(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', this.state.file.value);
    formData.append('type', this.props.type);
    formData.append('comment', this.state.textarea);
    this.props.updateQuoteStatus(formData);
    this.props.toggleFunc();
    return false;
  }

  handleTextareaChange(e) {
    this.setState({
      textarea: e.target.value,
    });
  }

  onUploadFile(e) {
    let error = null;
    if (e.target.files && e.target.files[0].size > 26214400) {
      error = 'File is too big';
      e.target.value = null;
    }
    this.setState({
      file: {
        error,
        value: e.target.files[0] || null,
      }
    })
  }

  render() {
    const { type, isShow, toggleFunc, icon, color, buttonsText } = this.props;
    return (
      <Modal
        isOpen={isShow}
      >
        <form onSubmit={this.onSubmitForm}>
          <ModalHeader toggle={toggleFunc}>
            <div><i className={`fa ${icon}`}/></div>
            <div className="title-text">{type} Estimate</div>
          </ModalHeader>
          <div className="modal-main-part">
            <div className="modal-why-ask">
              <div>Send an optional message with your approval.</div>
              <textarea value={this.state.textarea} onChange={this.handleTextareaChange}/>
            </div>
            <div className="modal-file">
              <div>Attach file:</div>
              <div className="text-danger">{this.state.file.error}</div>
              <div className="modal-file-field">
                <span className="modal-file-field-label">Upload a file. Max 25Mb. </span>
                <span className="modal-file-field-input">
                    <input type="file" onChange={this.onUploadFile}/>
                  </span>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-dark btn-inline" type='button' style={{ marginRight: '8px' }}
                    onClick={toggleFunc}>
              <span>Cancel</span>
            </button>
            <button type='submit' className={`btn btn-${color} btn-inline`} style={{ marginRight: '8px' }}>
              <span>{buttonsText ? buttonsText[0] : type}</span>
            </button>
          </div>
        </form>
      </Modal>
    )
  };
}

export default QuoteModalForm;



// WEBPACK FOOTER //
// ./src/containers/QuoteModalForm/index.js